export const JCInsurance_cn = {
  topTitle: '货运险的可靠之选',
  advantage1: '超低费率',
  advantage2: '理赔放心',
  advantage3: '品质服务',
  guarantee1: '杰西保，全面保障您的货物在海、陆、空的运输安全。',
  guarantee2:
    '填写下方信息，我们的专属服务团队将立即与您联系，帮助您快速完成投保。',
  fullName: '姓名',
  form_name_p: '请填写您的姓名',
  compName: '公司名称',
  form_comp_name_p: '请填写您的公司名称',
  email: '邮箱',
  form_email_p: '请填写您的邮箱',
  form_mobile_p: '请填写您的电话号',
  invalid_characters: '请输入有效信息',
  success_tips1: '提交成功',
  success_tips2: '我们会尽快联系您',
  success_tips: '提交成功,我们会尽快联系您。',
  form_country_code_p: '请选择',
}
export const JCInsurance_en = {
  topTitle: 'Your Trusted Partner for Safer Global Logistics',
  advantage1: 'Competitive Rates',
  advantage2: 'Fast Claims Procedures',
  advantage3: '1-on-1 Customer Service',
  guarantee1:
    'JCtrans Insurance provides comprehensive cargo insurance protection across sea, land, and air.',
  guarantee2:
    'Fill in the simple form below, and our team will reach out to get you set up instantly.',
  fullName: 'Full Name',
  form_name_p: 'Please fill in your name',
  compName: 'Company Name',
  form_comp_name_p: 'Please fill in your company name',
  email: 'Email',
  invalid_characters: 'Invalid characters',
  form_email_p: 'Please fill in your E-mail',
  form_mobile_p: 'Please fill in your Mobile',
  success_tips1: 'Submission successful!',
  success_tips2: 'We will contact you as soon as possible.',
  success_tips:
    'Submission successful!We will contact you as soon as possible.',
  form_country_code_p: 'Select',
}
